// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import NotifyNews from '../../notifyNews';
import './headerPC.scss';
import { TOP_IMAGES, Logo } from '../../../../../assets/imgs';

export default function HeaderPC(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    gotoLogin,
    isLogin,
    handleLogout,
    gotoMyCollection,
    gotoNews,
    gotoRegister,
    gotoMyPage,
    gotoPurchaseHistory,
    gotoLottery,
    gotoGuide,
    gotoFrequentlyQuestion,
  } = props;

  return (
    <header className="ol-header d-flex align-items-center justify-content-between">
      <div
        className="logo"
        onClick={() => {
          history.push('/');
        }}
      >
        <img src={Logo} alt="logo" />
      </div>
      <div className="menu d-flex">
        {isLogin ? (
          <div
            className="item-menu d-flex align-items-center justify-content-center"
            onClick={gotoMyCollection}
          >
            <svg
              className="svg_first"
              xmlns="http://www.w3.org/2000/svg"
              width="76.66"
              height="49.047"
              viewBox="0 0 76.66 49.047"
            >
              <g id="Group_12747" data-name="Group 12747" transform="translate(-730.543 -4309.649)">
                <path
                  id="Path_67296"
                  data-name="Path 67296"
                  d="M651.54,49.569l.044-1.65a.036.036,0,0,0-.033-.034c-.022,0-.032.012-.032.023L649.8,54.542a.919.919,0,0,1-1.012.737.879.879,0,0,1-.913-.737l-1.717-6.634c0-.011-.011-.023-.033-.023s-.032.012-.032.034l.044,1.65V54.52c0,.484-.243.759-.8.759a.692.692,0,0,1-.792-.759V46.884c0-.891.649-.967,1.222-.967.495,0,1.11.1,1.275.736l1.717,6.822c.011.066.021.12.077.12s.065-.032.088-.12l1.716-6.822c.165-.66.825-.736,1.342-.736.561,0,1.156.131,1.156.967V54.52c0,.484-.242.759-.815.759a.689.689,0,0,1-.781-.759Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67297"
                  data-name="Path 67297"
                  d="M660.692,46.323a.8.8,0,0,1,.672-.406.768.768,0,0,1,.7,1.21l-2.96,4.323v3.07a.692.692,0,0,1-.792.759c-.562,0-.8-.275-.8-.759V51.45l-2.96-4.323a.886.886,0,0,1-.142-.429.865.865,0,0,1,.869-.781.777.777,0,0,1,.648.406l2.388,3.521Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67298"
                  data-name="Path 67298"
                  d="M669.668,53.464a.424.424,0,0,0,.473-.473V48.744a.42.42,0,0,0-.473-.473h-5.622a.71.71,0,1,1,0-1.419h6.161c1.045,0,1.474.4,1.474,1.474V53.42c0,1.089-.451,1.474-1.474,1.474h-6.271a.715.715,0,1,1,0-1.43Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67299"
                  data-name="Path 67299"
                  d="M673.946,46.819c0-.319.088-.737.759-.737.528,0,.781.231.781.737v6.732c0,.176,0,.364.286.364a6.134,6.134,0,0,0,3.531-1.629,7.2,7.2,0,0,0,1.552-2.4c.132-.285.264-.439.572-.439s.88.209.88.693a6.141,6.141,0,0,1-1.32,2.5,7.943,7.943,0,0,1-4.379,2.585,5.637,5.637,0,0,1-1.484.265c-.771,0-1.178-.275-1.178-1.046Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67300"
                  data-name="Path 67300"
                  d="M690.623,47.467c.8,0,1.1.4,1.1.969a8.18,8.18,0,0,1-2.95,5.434,9.739,9.739,0,0,1-4.455,1.826.708.708,0,0,1-.726-.758c0-.474.209-.539,1.023-.738a6.513,6.513,0,0,0,5.468-5.182c0-.209-.143-.209-.418-.209h-3.245c-.551.748-1.937,2.289-2.685,2.289a.764.764,0,0,1-.716-.737c0-.3.089-.363.595-.738a8.734,8.734,0,0,0,2.3-2.673c.407-.814.484-1,.946-1,.33,0,.782.176.782.573a2.026,2.026,0,0,1-.353.945Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67301"
                  data-name="Path 67301"
                  d="M695.869,51.318a17.583,17.583,0,0,0-2.123-.891c-.319-.12-.627-.264-.627-.67a.676.676,0,0,1,.638-.727,9.365,9.365,0,0,1,2.189.7c.859.363,1.189.517,1.189,1a.739.739,0,0,1-.66.782,1.419,1.419,0,0,1-.606-.2m6.525-2.606a9.216,9.216,0,0,1-2.982,4.741,9.558,9.558,0,0,1-4.984,1.98.749.749,0,0,1-.759-.8c0-.583.506-.671.814-.715a8.227,8.227,0,0,0,4.192-1.728,7.832,7.832,0,0,0,1.936-2.816c.418-1.045.44-1.078.572-1.2a.512.512,0,0,1,.4-.132c.143,0,.815.1.815.672m-5.6-.254a16.61,16.61,0,0,0-2.123-.88c-.3-.11-.627-.265-.627-.671,0-.209.11-.737.638-.737a9.958,9.958,0,0,1,2.189.7c.88.374,1.189.527,1.189,1.012a.739.739,0,0,1-.661.781,1.5,1.5,0,0,1-.6-.209"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67302"
                  data-name="Path 67302"
                  d="M704.372,52.286a.579.579,0,0,1-.649-.627.573.573,0,0,1,.649-.627h4.687V49.845a.329.329,0,0,0-.375-.375h-4.4a.644.644,0,1,1,0-1.288h4.862c1.045,0,1.277.53,1.277,1.278V54c0,1.023-.495,1.276-1.277,1.276H704.2a.593.593,0,0,1-.672-.649.605.605,0,0,1,.672-.66h4.488a.328.328,0,0,0,.375-.374v-1.31Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67303"
                  data-name="Path 67303"
                  d="M712.654,46.555c.209,0,.407.077,1.222.516,2.453,1.343,2.453,1.541,2.453,1.871a.9.9,0,0,1-.737.815c-.286,0-.529-.166-1.177-.617a20.3,20.3,0,0,0-1.947-1.133c-.253-.132-.551-.3-.551-.671a.847.847,0,0,1,.6-.771.928.928,0,0,1,.142-.01m8.549,1.694a10.511,10.511,0,0,1-2.08,4.147,8.207,8.207,0,0,1-4.39,2.63,9.571,9.571,0,0,1-1.793.33.758.758,0,0,1-.769-.836c0-.55.307-.66.824-.726,3.114-.363,5.336-1.563,6.667-5.468.2-.572.265-.77.693-.77a1.344,1.344,0,0,1,.276.033.679.679,0,0,1,.572.66"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67304"
                  data-name="Path 67304"
                  d="M682.417,6.7,666.6,13.649a.5.5,0,0,0-.3.458V32.321a.5.5,0,0,0,.3.457l15.816,6.954a.551.551,0,0,0,.45,0l15.816-6.954a.5.5,0,0,0,.3-.457V14.107a.5.5,0,0,0-.3-.458L682.867,6.7a.559.559,0,0,0-.45,0"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67305"
                  data-name="Path 67305"
                  d="M677.6,15.8a13.253,13.253,0,0,0,10.091,0c1.376-.656,2.134-1.539,2.134-2.484s-.758-1.828-2.134-2.485a13.265,13.265,0,0,0-10.091,0c-1.376.657-2.134,1.538-2.134,2.485s.758,1.828,2.134,2.484"
                  transform="translate(86 4303)"
                  fill="#ce323a"
                />
                <path
                  id="Path_67306"
                  data-name="Path 67306"
                  d="M695.816,15.42l-13.287,6.1V35.85"
                  transform="translate(86 4303)"
                  fill="none"
                  stroke="#ce323a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                />
                <line
                  id="Line_668"
                  data-name="Line 668"
                  x1="13.35"
                  y1="6.101"
                  transform="translate(755.179 4318.42)"
                  fill="none"
                  stroke="#ce323a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                />
              </g>
            </svg>

            <svg
              className="svg_last"
              xmlns="http://www.w3.org/2000/svg"
              width="76.66"
              height="49.047"
              viewBox="0 0 76.66 49.047"
            >
              <g id="Group_12842" data-name="Group 12842" transform="translate(-644 -12.649)">
                <g id="Group_12841" data-name="Group 12841">
                  <path
                    id="Path_67296"
                    data-name="Path 67296"
                    d="M651.54,49.569l.044-1.65a.036.036,0,0,0-.033-.034c-.022,0-.032.012-.032.023L649.8,54.542a.919.919,0,0,1-1.012.737.879.879,0,0,1-.913-.737l-1.717-6.634c0-.011-.011-.023-.033-.023s-.032.012-.032.034l.044,1.65V54.52c0,.484-.243.759-.8.759a.692.692,0,0,1-.792-.759V46.884c0-.891.649-.967,1.222-.967.495,0,1.11.1,1.275.736l1.717,6.822c.011.066.021.12.077.12s.065-.032.088-.12l1.716-6.822c.165-.66.825-.736,1.342-.736.561,0,1.156.131,1.156.967V54.52c0,.484-.242.759-.815.759a.689.689,0,0,1-.781-.759Z"
                    transform="translate(-0.543 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67297"
                    data-name="Path 67297"
                    d="M660.692,46.323a.8.8,0,0,1,.672-.406.768.768,0,0,1,.7,1.21l-2.96,4.323v3.07a.692.692,0,0,1-.792.759c-.562,0-.8-.275-.8-.759V51.45l-2.96-4.323a.886.886,0,0,1-.142-.429.865.865,0,0,1,.869-.781.777.777,0,0,1,.648.406l2.388,3.521Z"
                    transform="translate(-0.543 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67298"
                    data-name="Path 67298"
                    d="M669.668,53.464a.424.424,0,0,0,.473-.473V48.744a.42.42,0,0,0-.473-.473h-5.622a.71.71,0,1,1,0-1.419h6.161c1.045,0,1.474.4,1.474,1.474V53.42c0,1.089-.451,1.474-1.474,1.474h-6.271a.715.715,0,1,1,0-1.43Z"
                    transform="translate(-0.543 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67299"
                    data-name="Path 67299"
                    d="M673.946,46.819c0-.319.088-.737.759-.737.528,0,.781.231.781.737v6.732c0,.176,0,.364.286.364a6.134,6.134,0,0,0,3.531-1.629,7.2,7.2,0,0,0,1.552-2.4c.132-.285.264-.439.572-.439s.88.209.88.693a6.141,6.141,0,0,1-1.32,2.5,7.943,7.943,0,0,1-4.379,2.585,5.637,5.637,0,0,1-1.484.265c-.771,0-1.178-.275-1.178-1.046Z"
                    transform="translate(-0.543 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67300"
                    data-name="Path 67300"
                    d="M690.623,47.467c.8,0,1.1.4,1.1.969a8.18,8.18,0,0,1-2.95,5.434,9.739,9.739,0,0,1-4.455,1.826.708.708,0,0,1-.726-.758c0-.474.209-.539,1.023-.738a6.513,6.513,0,0,0,5.468-5.182c0-.209-.143-.209-.418-.209h-3.245c-.551.748-1.937,2.289-2.685,2.289a.764.764,0,0,1-.716-.737c0-.3.089-.363.595-.738a8.734,8.734,0,0,0,2.3-2.673c.407-.814.484-1,.946-1,.33,0,.782.176.782.573a2.026,2.026,0,0,1-.353.945Z"
                    transform="translate(-0.543 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67301"
                    data-name="Path 67301"
                    d="M695.869,51.318a17.583,17.583,0,0,0-2.123-.891c-.319-.12-.627-.264-.627-.67a.676.676,0,0,1,.638-.727,9.365,9.365,0,0,1,2.189.7c.859.363,1.189.517,1.189,1a.739.739,0,0,1-.66.782,1.419,1.419,0,0,1-.606-.2m6.525-2.606a9.216,9.216,0,0,1-2.982,4.741,9.558,9.558,0,0,1-4.984,1.98.749.749,0,0,1-.759-.8c0-.583.506-.671.814-.715a8.227,8.227,0,0,0,4.192-1.728,7.832,7.832,0,0,0,1.936-2.816c.418-1.045.44-1.078.572-1.2a.512.512,0,0,1,.4-.132c.143,0,.815.1.815.672m-5.6-.254a16.61,16.61,0,0,0-2.123-.88c-.3-.11-.627-.265-.627-.671,0-.209.11-.737.638-.737a9.958,9.958,0,0,1,2.189.7c.88.374,1.189.527,1.189,1.012a.739.739,0,0,1-.661.781,1.5,1.5,0,0,1-.6-.209"
                    transform="translate(-0.543 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67302"
                    data-name="Path 67302"
                    d="M704.372,52.286a.579.579,0,0,1-.649-.627.573.573,0,0,1,.649-.627h4.687V49.845a.329.329,0,0,0-.375-.375h-4.4a.644.644,0,1,1,0-1.288h4.862c1.045,0,1.277.53,1.277,1.278V54c0,1.023-.495,1.276-1.277,1.276H704.2a.593.593,0,0,1-.672-.649.605.605,0,0,1,.672-.66h4.488a.328.328,0,0,0,.375-.374v-1.31Z"
                    transform="translate(-0.543 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67303"
                    data-name="Path 67303"
                    d="M712.654,46.555c.209,0,.407.077,1.222.516,2.453,1.343,2.453,1.541,2.453,1.871a.9.9,0,0,1-.737.815c-.286,0-.529-.166-1.177-.617a20.3,20.3,0,0,0-1.947-1.133c-.253-.132-.551-.3-.551-.671a.847.847,0,0,1,.6-.771.928.928,0,0,1,.142-.01m8.549,1.694a10.511,10.511,0,0,1-2.08,4.147,8.207,8.207,0,0,1-4.39,2.63,9.571,9.571,0,0,1-1.793.33.758.758,0,0,1-.769-.836c0-.55.307-.66.824-.726,3.114-.363,5.336-1.563,6.667-5.468.2-.572.265-.77.693-.77a1.344,1.344,0,0,1,.276.033.679.679,0,0,1,.572.66"
                    transform="translate(-0.543 6)"
                    fill="#f7cf91"
                  />
                </g>
                <path
                  id="Path_67304"
                  data-name="Path 67304"
                  d="M682.417,6.7,666.6,13.649a.5.5,0,0,0-.3.458V32.321a.5.5,0,0,0,.3.457l15.816,6.954a.551.551,0,0,0,.45,0l15.816-6.954a.5.5,0,0,0,.3-.457V14.107a.5.5,0,0,0-.3-.458L682.867,6.7a.559.559,0,0,0-.45,0"
                  transform="translate(-0.543 6)"
                  fill="#f7cf91"
                />
                <path
                  id="Path_67305"
                  data-name="Path 67305"
                  d="M677.6,15.8a13.253,13.253,0,0,0,10.091,0c1.376-.656,2.134-1.539,2.134-2.484s-.758-1.828-2.134-2.485a13.265,13.265,0,0,0-10.091,0c-1.376.657-2.134,1.538-2.134,2.485s.758,1.828,2.134,2.484"
                  transform="translate(-0.543 6)"
                  fill="#ce323a"
                />
                <path
                  id="Path_67306"
                  data-name="Path 67306"
                  d="M695.816,15.42l-13.287,6.1V35.85"
                  transform="translate(-0.543 6)"
                  fill="none"
                  stroke="#ce323a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                />
                <line
                  id="Line_668"
                  data-name="Line 668"
                  x1="13.35"
                  y1="6.101"
                  transform="translate(668.636 21.42)"
                  fill="none"
                  stroke="#ce323a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                />
              </g>
            </svg>
            <div className="border-menu"></div>
          </div>
        ) : (
          <div />
        )}
        <div
          className="item-menu d-flex align-items-center justify-content-center"
          onClick={gotoNews}
        >
          <svg
            className="svg_first"
            xmlns="http://www.w3.org/2000/svg"
            width={42}
            height="49.39"
            viewBox="0 0 42 49.39"
          >
            <g id="Group_12746" data-name="Group 12746" transform="translate(-862.776 -4309.648)">
              <path
                id="Path_67289"
                data-name="Path 67289"
                d="M781.178,49.657a6.232,6.232,0,0,1,1.055-.088,5.439,5.439,0,0,1,3.015.815,2.931,2.931,0,0,1-1.045,4.96,5.921,5.921,0,0,1-1.9.288c-.441,0-1.013,0-1.013-.716,0-.6.474-.6.771-.6.781,0,2.618,0,2.618-1.717,0-1.54-1.364-1.759-2.4-1.759a5.427,5.427,0,0,0-1.1.088v1.715c0,1.056,0,2.96-2.036,2.96a2.31,2.31,0,0,1-2.366-2.377c0-2.1,2.058-2.9,3-3.255V48.721c-.671.023-2.047.023-2.079.023-.386,0-.847,0-.847-.671s.517-.66.814-.66c1.331,0,1.485,0,2.112-.022V46.61c0-.275.011-.738.694-.738s.7.441.7.738v.715c.934-.045,1.045-.045,1.143-.045a.608.608,0,0,1,.715.66c0,.474-.285.6-.374.617a7.646,7.646,0,0,1-1.484.1ZM779.8,51.3c-.583.232-1.672.749-1.672,1.827a1.052,1.052,0,0,0,.946,1.122c.495,0,.726-.463.726-1.651Zm3.95-4.973c.7,0,2.706,1.729,2.706,2.486a.78.78,0,0,1-.781.727c-.3,0-.385-.121-.738-.615a5.138,5.138,0,0,0-1.54-1.431.583.583,0,0,1-.165-.946.813.813,0,0,1,.518-.221"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
              <path
                id="Path_67290"
                data-name="Path 67290"
                d="M787.975,51.461a.574.574,0,0,1-.671-.616c0-.451.154-.693.671-.693h1.848V48.3h-.561a7.991,7.991,0,0,1-.616,1.013.642.642,0,0,1-.54.319.753.753,0,0,1-.748-.638c0-.2.011-.22.5-.936a9.729,9.729,0,0,0,.923-1.969c.111-.3.221-.472.573-.472s.748.2.748.56a2.86,2.86,0,0,1-.242.825h2.233a.575.575,0,0,1,.672.617c0,.451-.155.681-.672.681h-.924v1.849h1.166c.221,0,.671.022.671.616,0,.484-.176.693-.671.693h-1.287a.944.944,0,0,1-.022.165,7.522,7.522,0,0,0,1.662,2.454.68.68,0,0,1-.462,1.2c-.253,0-.408-.121-.694-.485a10.2,10.2,0,0,1-.957-1.561,6.126,6.126,0,0,1-1.882,2.552c-.241.2-.351.253-.505.253a.834.834,0,0,1-.759-.759.808.808,0,0,1,.374-.583,4.917,4.917,0,0,0,1.9-3.235Zm9.439,3.07c0,.957-.4,1.276-1.266,1.276h-1.836c-.87,0-1.265-.319-1.265-1.276V47.479c0-.979.418-1.277,1.265-1.277h1.836c.848,0,1.266.287,1.266,1.277ZM796.083,47.9a.338.338,0,0,0-.385-.385h-.979a.335.335,0,0,0-.374.385V54.09a.328.328,0,0,0,.374.374h.979a.336.336,0,0,0,.385-.374Z"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
              <path
                id="Path_67291"
                data-name="Path 67291"
                d="M804.19,49.448c1.254,0,3.367.462,3.367,2.762,0,2.925-2.861,3.322-4.819,3.322a10.707,10.707,0,0,1-2.728-.309.664.664,0,0,1-.4-.637.608.608,0,0,1,.639-.661,2.107,2.107,0,0,1,.45.067,10.975,10.975,0,0,0,1.97.2,5.709,5.709,0,0,0,2.42-.451,1.575,1.575,0,0,0,.935-1.541,1.355,1.355,0,0,0-.516-1.067,2.729,2.729,0,0,0-1.541-.407,4.9,4.9,0,0,0-3.366,1.222c-.308.308-.462.45-.859.45-.516,0-.748-.308-.748-.924s.1-2.421.165-2.948c.056-.385.132-.727.716-.727.56,0,.748.254.748.606,0,.055-.066.648-.077.769a12.427,12.427,0,0,0-.111,1.42,6.674,6.674,0,0,1,3.752-1.144m1.727-1.672a.809.809,0,0,1-.55.132,32.612,32.612,0,0,1-4.081-.407c-.99-.155-1.309-.264-1.309-.76,0-.066,0-.7.627-.7.131,0,.572.088.858.142a23.931,23.931,0,0,0,3.443.342c.891.032,1.243.076,1.243.758a.69.69,0,0,1-.231.5"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
              <path
                id="Path_67292"
                data-name="Path 67292"
                d="M811.835,52.276c-.012,1.539.3,1.858,2.409,1.858a15.167,15.167,0,0,0,2.234-.153,3.984,3.984,0,0,1,.637-.056.622.622,0,0,1,.627.694.643.643,0,0,1-.583.692,17.518,17.518,0,0,1-2.761.177c-2.178,0-3.311-.275-3.785-1.519a7.013,7.013,0,0,1-.2-1.683V49.778c-.165.012-.924.044-1.078.044a.623.623,0,0,1-.7-.683c0-.637.473-.67.737-.681.286-.011.759-.022,1.057-.034v-1.6c0-.309.044-.748.715-.748.6,0,.725.33.725.759l-.011,1.54c1.662-.055,1.849-.055,3.532-.1,0-.23-.032-1.287-.032-1.5,0-.352,0-.869.725-.869.484,0,.683.154.737.617.023.153.034,1.463.034,1.716.483,0,.99-.011,1.176-.011.265,0,.748,0,.748.671,0,.583-.384.671-.737.682-.011,0-1.056.022-1.177.022a7.406,7.406,0,0,1-.3,2.695,1.675,1.675,0,0,1-1.485.671,4.484,4.484,0,0,1-1.727-.352.653.653,0,0,1-.452-.627.61.61,0,0,1,.595-.66,1.778,1.778,0,0,1,.605.154,2.4,2.4,0,0,0,.726.133c.33,0,.506-.111.55-.606.011-.142.022-1.155.033-1.375-1.617.034-1.815.034-3.564.1Z"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
              <path
                id="Path_67293"
                data-name="Path 67293"
                d="M807.621,21.753a9.807,9.807,0,0,0-2.932-7.52,11.3,11.3,0,0,0-14.158,0,9.807,9.807,0,0,0-2.932,7.52c0,7.927-2.37,11.714-3.429,13.471a.945.945,0,0,0,.815,1.433h25.25a.945.945,0,0,0,.815-1.433c-1.059-1.757-3.429-5.544-3.429-13.471"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
              <path
                id="Path_67294"
                data-name="Path 67294"
                d="M794.64,35.85a.49.49,0,0,0-.5.6,3.518,3.518,0,0,0,6.932,0,.49.49,0,0,0-.5-.6Z"
                transform="translate(86 4303)"
                fill="none"
                stroke="#ffffe5"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                id="Path_67295"
                data-name="Path 67295"
                d="M800.586,9.624a2.975,2.975,0,1,1-2.976-2.976,2.976,2.976,0,0,1,2.976,2.976"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
            </g>
          </svg>

          <svg
            className="svg_last"
            xmlns="http://www.w3.org/2000/svg"
            width={42}
            height="49.39"
            viewBox="0 0 42 49.39"
          >
            <g id="Group_12845" data-name="Group 12845" transform="translate(-775.776 -12.029)">
              <g id="Group_12843" data-name="Group 12843">
                <path
                  id="Path_67289"
                  data-name="Path 67289"
                  d="M781.178,49.657a6.232,6.232,0,0,1,1.055-.088,5.439,5.439,0,0,1,3.015.815,2.931,2.931,0,0,1-1.045,4.96,5.921,5.921,0,0,1-1.9.288c-.441,0-1.013,0-1.013-.716,0-.6.474-.6.771-.6.781,0,2.618,0,2.618-1.717,0-1.54-1.364-1.759-2.4-1.759a5.427,5.427,0,0,0-1.1.088v1.715c0,1.056,0,2.96-2.036,2.96a2.31,2.31,0,0,1-2.366-2.377c0-2.1,2.058-2.9,3-3.255V48.721c-.671.023-2.047.023-2.079.023-.386,0-.847,0-.847-.671s.517-.66.814-.66c1.331,0,1.485,0,2.112-.022V46.61c0-.275.011-.738.694-.738s.7.441.7.738v.715c.934-.045,1.045-.045,1.143-.045a.608.608,0,0,1,.715.66c0,.474-.285.6-.374.617a7.646,7.646,0,0,1-1.484.1ZM779.8,51.3c-.583.232-1.672.749-1.672,1.827a1.052,1.052,0,0,0,.946,1.122c.495,0,.726-.463.726-1.651Zm3.95-4.973c.7,0,2.706,1.729,2.706,2.486a.78.78,0,0,1-.781.727c-.3,0-.385-.121-.738-.615a5.138,5.138,0,0,0-1.54-1.431.583.583,0,0,1-.165-.946.813.813,0,0,1,.518-.221"
                  transform="translate(-1 5.381)"
                  fill="#f7cf91"
                />
                <path
                  id="Path_67290"
                  data-name="Path 67290"
                  d="M787.975,51.461a.574.574,0,0,1-.671-.616c0-.451.154-.693.671-.693h1.848V48.3h-.561a7.991,7.991,0,0,1-.616,1.013.642.642,0,0,1-.54.319.753.753,0,0,1-.748-.638c0-.2.011-.22.5-.936a9.729,9.729,0,0,0,.923-1.969c.111-.3.221-.472.573-.472s.748.2.748.56a2.86,2.86,0,0,1-.242.825h2.233a.575.575,0,0,1,.672.617c0,.451-.155.681-.672.681h-.924v1.849h1.166c.221,0,.671.022.671.616,0,.484-.176.693-.671.693h-1.287a.944.944,0,0,1-.022.165,7.522,7.522,0,0,0,1.662,2.454.68.68,0,0,1-.462,1.2c-.253,0-.408-.121-.694-.485a10.2,10.2,0,0,1-.957-1.561,6.126,6.126,0,0,1-1.882,2.552c-.241.2-.351.253-.505.253a.834.834,0,0,1-.759-.759.808.808,0,0,1,.374-.583,4.917,4.917,0,0,0,1.9-3.235Zm9.439,3.07c0,.957-.4,1.276-1.266,1.276h-1.836c-.87,0-1.265-.319-1.265-1.276V47.479c0-.979.418-1.277,1.265-1.277h1.836c.848,0,1.266.287,1.266,1.277ZM796.083,47.9a.338.338,0,0,0-.385-.385h-.979a.335.335,0,0,0-.374.385V54.09a.328.328,0,0,0,.374.374h.979a.336.336,0,0,0,.385-.374Z"
                  transform="translate(-1 5.381)"
                  fill="#f7cf91"
                />
                <path
                  id="Path_67291"
                  data-name="Path 67291"
                  d="M804.19,49.448c1.254,0,3.367.462,3.367,2.762,0,2.925-2.861,3.322-4.819,3.322a10.707,10.707,0,0,1-2.728-.309.664.664,0,0,1-.4-.637.608.608,0,0,1,.639-.661,2.107,2.107,0,0,1,.45.067,10.975,10.975,0,0,0,1.97.2,5.709,5.709,0,0,0,2.42-.451,1.575,1.575,0,0,0,.935-1.541,1.355,1.355,0,0,0-.516-1.067,2.729,2.729,0,0,0-1.541-.407,4.9,4.9,0,0,0-3.366,1.222c-.308.308-.462.45-.859.45-.516,0-.748-.308-.748-.924s.1-2.421.165-2.948c.056-.385.132-.727.716-.727.56,0,.748.254.748.606,0,.055-.066.648-.077.769a12.427,12.427,0,0,0-.111,1.42,6.674,6.674,0,0,1,3.752-1.144m1.727-1.672a.809.809,0,0,1-.55.132,32.612,32.612,0,0,1-4.081-.407c-.99-.155-1.309-.264-1.309-.76,0-.066,0-.7.627-.7.131,0,.572.088.858.142a23.931,23.931,0,0,0,3.443.342c.891.032,1.243.076,1.243.758a.69.69,0,0,1-.231.5"
                  transform="translate(-1 5.381)"
                  fill="#f7cf91"
                />
                <path
                  id="Path_67292"
                  data-name="Path 67292"
                  d="M811.835,52.276c-.012,1.539.3,1.858,2.409,1.858a15.167,15.167,0,0,0,2.234-.153,3.984,3.984,0,0,1,.637-.056.622.622,0,0,1,.627.694.643.643,0,0,1-.583.692,17.518,17.518,0,0,1-2.761.177c-2.178,0-3.311-.275-3.785-1.519a7.013,7.013,0,0,1-.2-1.683V49.778c-.165.012-.924.044-1.078.044a.623.623,0,0,1-.7-.683c0-.637.473-.67.737-.681.286-.011.759-.022,1.057-.034v-1.6c0-.309.044-.748.715-.748.6,0,.725.33.725.759l-.011,1.54c1.662-.055,1.849-.055,3.532-.1,0-.23-.032-1.287-.032-1.5,0-.352,0-.869.725-.869.484,0,.683.154.737.617.023.153.034,1.463.034,1.716.483,0,.99-.011,1.176-.011.265,0,.748,0,.748.671,0,.583-.384.671-.737.682-.011,0-1.056.022-1.177.022a7.406,7.406,0,0,1-.3,2.695,1.675,1.675,0,0,1-1.485.671,4.484,4.484,0,0,1-1.727-.352.653.653,0,0,1-.452-.627.61.61,0,0,1,.595-.66,1.778,1.778,0,0,1,.605.154,2.4,2.4,0,0,0,.726.133c.33,0,.506-.111.55-.606.011-.142.022-1.155.033-1.375-1.617.034-1.815.034-3.564.1Z"
                  transform="translate(-1 5.381)"
                  fill="#f7cf91"
                />
              </g>
              <g id="Group_12844" data-name="Group 12844">
                <path
                  id="Path_67293"
                  data-name="Path 67293"
                  d="M807.621,21.753a9.807,9.807,0,0,0-2.932-7.52,11.3,11.3,0,0,0-14.158,0,9.807,9.807,0,0,0-2.932,7.52c0,7.927-2.37,11.714-3.429,13.471a.945.945,0,0,0,.815,1.433h25.25a.945.945,0,0,0,.815-1.433c-1.059-1.757-3.429-5.544-3.429-13.471"
                  transform="translate(-1 5.381)"
                  fill="#f7cf91"
                />
                <path
                  id="Path_67294"
                  data-name="Path 67294"
                  d="M794.64,35.85a.49.49,0,0,0-.5.6,3.518,3.518,0,0,0,6.932,0,.49.49,0,0,0-.5-.6Z"
                  transform="translate(-1 5.381)"
                  fill="none"
                  stroke="#f7cf91"
                  strokeMiterlimit={10}
                  strokeWidth={1}
                />
                <path
                  id="Path_67295"
                  data-name="Path 67295"
                  d="M800.586,9.624a2.975,2.975,0,1,1-2.976-2.976,2.976,2.976,0,0,1,2.976,2.976"
                  transform="translate(-1 5.381)"
                  fill="#f7cf91"
                />
              </g>
            </g>
          </svg>
          <div className="border-menu"></div>
          {isLogin && <NotifyNews />}
        </div>

        <div
          className="item-menu d-flex align-items-center justify-content-center"
          onClick={() => {
            history.push('/lottery');
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="40.943"
            height="46.206"
            viewBox="0 0 40.943 46.206"
            className="svg_first"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_8490"
                  data-name="Rectangle 8490"
                  width="35.706"
                  height="25.062"
                  transform="translate(0 0)"
                  fill="none"
                />
              </clipPath>
              <clipPath id="clip-path-3">
                <rect
                  id="Rectangle_8488"
                  data-name="Rectangle 8488"
                  width="40.943"
                  height="10.408"
                  transform="translate(0 0)"
                  fill="none"
                />
              </clipPath>
            </defs>
            <g id="Group_13773" data-name="Group 13773" transform="translate(-755.979 -15.202)">
              <g id="Group_13771" data-name="Group 13771" transform="translate(758.599 15.202)">
                <g id="Group_13768" data-name="Group 13768">
                  <g id="Group_13767" data-name="Group 13767" clipPath="url(#clip-path)">
                    <rect
                      id="Rectangle_8489"
                      data-name="Rectangle 8489"
                      width="33.706"
                      height="23.062"
                      transform="translate(1 1)"
                      fill="none"
                      stroke="#ffffe5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                    />
                  </g>
                </g>
                <path
                  id="Path_70615"
                  data-name="Path 70615"
                  d="M.679,12.561.746,24.028l17.2.535L.609,8.539Z"
                  fill="#ffffe5"
                />
                <g id="Group_13770" data-name="Group 13770">
                  <g id="Group_13769" data-name="Group 13769" clipPath="url(#clip-path)">
                    <line
                      id="Line_744"
                      data-name="Line 744"
                      x2="21.463"
                      y2="20.396"
                      transform="translate(0.887 3.468)"
                      fill="none"
                      stroke="#ffffe5"
                      strokeWidth="2.5"
                    />
                  </g>
                </g>
              </g>
              <g id="Group_13772" data-name="Group 13772" transform="translate(755.979 51)">
                <g id="Group_13764" data-name="Group 13764" clipPath="url(#clip-path-3)">
                  <path
                    id="Path_70611"
                    data-name="Path 70611"
                    d="M.836,4.115A39.107,39.107,0,0,0,6.272.7,1.136,1.136,0,0,1,7.009.351a.782.782,0,0,1,.847.727c0,.319-.166.506-.738.924a36.126,36.126,0,0,1-4.7,2.717c-.462.232-.583.341-.583.507s.109.264.495.428A37.336,37.336,0,0,1,6.953,8C8.24,8.768,8.4,8.977,8.4,9.373a.843.843,0,0,1-.8.793,1.336,1.336,0,0,1-.8-.342A25.52,25.52,0,0,0,2.6,7.239C2.321,7.095,1.046,6.523.8,6.392A1.232,1.232,0,0,1,0,5.281,1.325,1.325,0,0,1,.836,4.115"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_70612"
                    data-name="Path 70612"
                    d="M11.847,1.178c0,.285-.066,1.572-.077,1.837-.077,2.035-.088,2.421-.088,2.816,0,1.44,0,2.806,2.157,2.806a2.93,2.93,0,0,0,3.289-2.6c.132-.759.2-1.078.8-1.078.176,0,.836.022.836.671a5.229,5.229,0,0,1-.935,2.64,4.518,4.518,0,0,1-3.939,1.76,4.125,4.125,0,0,1-2.651-.748C10.417,8.614,10.2,7.822,10.2,6.293c0-1.947.077-5.148.077-5.2.044-.441.187-.727.814-.727.759-.011.759.583.759.815m3.388.67c0-.231.254-.34.407-.34s.243.076.495.483a3.055,3.055,0,0,1,.43.968c0,.3-.319.353-.418.353-.055,0-.187,0-.308-.209-.044-.088-.22-.462-.264-.54-.286-.528-.342-.637-.342-.715m1.255-.307a.561.561,0,0,1-.066-.221c0-.22.253-.33.407-.33s.3.088.583.606a2.78,2.78,0,0,1,.341.814c0,.252-.286.352-.418.352a.367.367,0,0,1-.308-.221c-.077-.143-.176-.373-.253-.506-.044-.088-.242-.418-.286-.494"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_70613"
                    data-name="Path 70613"
                    d="M29.207,4.412a.634.634,0,0,1,.7.726c0,.594-.319.748-.7.748H20.361c-.263,0-.7-.066-.7-.726,0-.627.363-.748.7-.748Z"
                    fill="#ffffe5"
                  />
                  <path
                    id="Path_70614"
                    data-name="Path 70614"
                    d="M37.621,8.945c0,.307.022.307.748.307.165,0,.88,0,.969-.01.153-.033.165-.078.241-.506.077-.374.133-.693.66-.693.418,0,.693.2.693.649,0,.033-.054,1.122-.495,1.429a1.309,1.309,0,0,1-.825.176c-.3.012-.77.012-.88.012a15.694,15.694,0,0,1-1.793-.033c-.671-.11-.716-.594-.716-1.21v-.7H35.08a2.746,2.746,0,0,1-1.408,1.517,7.006,7.006,0,0,1-2.355.53.609.609,0,0,1-.7-.651c0-.461.374-.516.572-.539,1.221-.131,1.87-.2,2.343-.857H32.8c-.484,0-1.188,0-1.188-.947V5.457c0-.946.7-.957,1.188-.957h5.9c.484,0,1.188.011,1.188.957V7.415c0,.947-.7.947-1.188.947H37.621ZM40.349.782c.176,0,.594,0,.594.593s-.362.606-.594.606H37.511c-.319.451-.858,1.111-1.276,1.111a.644.644,0,0,1-.627-.594c-.045.5-.352.539-.66.539H34.4v.352h1.112c.175,0,.451.022.451.418,0,.318-.176.407-.451.407H32.044c-.947,0-1.156-.177-1.156-1.155V1.453c0-.968.2-1.166,1.156-1.166h3.431A.385.385,0,0,1,35.926.7c0,.364-.252.408-.451.408H34.4V1.5h.551c.23,0,.671,0,.671.627v.264c.021-.209.088-.274.6-.868a4.052,4.052,0,0,0,.529-.781c.242-.451.4-.738.858-.738.231,0,.649.055.649.462a.9.9,0,0,1-.077.32ZM33.242,1.5V1.112h-.935a.2.2,0,0,0-.219.219V1.5Zm-1.154.958h2.167a.193.193,0,1,0,0-.385H32.088Zm1.154.572H32.088c0,.22,0,.363.219.363h.935Zm.089,2.233c-.265,0-.265.177-.265.353H38.49c0-.176,0-.353-.264-.353Zm5.159.99H33.066v.33H38.49Zm-5.424,1c0,.176,0,.352.265.352h4.9c.264,0,.264-.176.264-.352Zm4-3.234a.5.5,0,0,1-.583-.55.5.5,0,0,1,.583-.561h2.971a.5.5,0,0,1,.583.55.506.506,0,0,1-.583.561Z"
                    fill="#ffffe5"
                  />
                </g>
              </g>
            </g>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="40.943"
            height="46.207"
            viewBox="0 0 40.943 46.207"
            className="svg_last"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_8491"
                  data-name="Rectangle 8491"
                  width="35.706"
                  height="25.062"
                  transform="translate(0 0)"
                  fill="none"
                />
              </clipPath>
            </defs>
            <g id="Group_13798" data-name="Group 13798" transform="translate(-755.979 -15.202)">
              <g id="Group_13771" data-name="Group 13771" transform="translate(758.599 15.202)">
                <g id="Group_13768" data-name="Group 13768">
                  <g id="Group_13799" data-name="Group 13799">
                    <rect
                      id="Rectangle_8489"
                      data-name="Rectangle 8489"
                      width="33.706"
                      height="23.062"
                      transform="translate(1 1)"
                      fill="none"
                      stroke="#f7cf91"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                    />
                  </g>
                </g>
                <path
                  id="Path_70615"
                  data-name="Path 70615"
                  d="M.679,12.561.746,24.028l17.2.535L.609,8.539Z"
                  fill="#f7cf91"
                />
                <g id="Group_13770" data-name="Group 13770">
                  <g id="Group_13769" data-name="Group 13769" clipPath="url(#clip-path)">
                    <line
                      id="Line_744"
                      data-name="Line 744"
                      x2="21.463"
                      y2="20.396"
                      transform="translate(0.887 3.468)"
                      fill="none"
                      stroke="#f7cf91"
                      strokeWidth="2.5"
                    />
                  </g>
                </g>
              </g>
              <path
                id="Path_70611"
                data-name="Path 70611"
                d="M.836,4.115A39.107,39.107,0,0,0,6.272.7,1.136,1.136,0,0,1,7.009.351a.782.782,0,0,1,.847.727c0,.319-.166.506-.738.924a36.126,36.126,0,0,1-4.7,2.717c-.462.232-.583.341-.583.507s.109.264.495.428A37.336,37.336,0,0,1,6.953,8C8.24,8.768,8.4,8.977,8.4,9.373a.843.843,0,0,1-.8.793,1.336,1.336,0,0,1-.8-.342A25.52,25.52,0,0,0,2.6,7.239C2.321,7.095,1.046,6.523.8,6.392A1.232,1.232,0,0,1,0,5.281,1.325,1.325,0,0,1,.836,4.115"
                transform="translate(755.979 51)"
                fill="#f7cf91"
              />
              <path
                id="Path_70612"
                data-name="Path 70612"
                d="M11.847,1.178c0,.285-.066,1.572-.077,1.837-.077,2.035-.088,2.421-.088,2.816,0,1.44,0,2.806,2.157,2.806a2.93,2.93,0,0,0,3.289-2.6c.132-.759.2-1.078.8-1.078.176,0,.836.022.836.671a5.229,5.229,0,0,1-.935,2.64,4.518,4.518,0,0,1-3.939,1.76,4.125,4.125,0,0,1-2.651-.748C10.417,8.614,10.2,7.822,10.2,6.293c0-1.947.077-5.148.077-5.2.044-.441.187-.727.814-.727.759-.011.759.583.759.815m3.388.67c0-.231.254-.34.407-.34s.243.076.495.483a3.055,3.055,0,0,1,.43.968c0,.3-.319.353-.418.353-.055,0-.187,0-.308-.209-.044-.088-.22-.462-.264-.54-.286-.528-.342-.637-.342-.715m1.255-.307a.561.561,0,0,1-.066-.221c0-.22.253-.33.407-.33s.3.088.583.606a2.78,2.78,0,0,1,.341.814c0,.252-.286.352-.418.352a.367.367,0,0,1-.308-.221c-.077-.143-.176-.373-.253-.506-.044-.088-.242-.418-.286-.494"
                transform="translate(755.979 51)"
                fill="#f7cf91"
              />
              <path
                id="Path_70613"
                data-name="Path 70613"
                d="M29.207,4.412a.634.634,0,0,1,.7.726c0,.594-.319.748-.7.748H20.361c-.263,0-.7-.066-.7-.726,0-.627.363-.748.7-.748Z"
                transform="translate(755.979 51)"
                fill="#f7cf91"
              />
              <path
                id="Path_70614"
                data-name="Path 70614"
                d="M37.621,8.945c0,.307.022.307.748.307.165,0,.88,0,.969-.01.153-.033.165-.078.241-.506.077-.374.133-.693.66-.693.418,0,.693.2.693.649,0,.033-.054,1.122-.495,1.429a1.309,1.309,0,0,1-.825.176c-.3.012-.77.012-.88.012a15.694,15.694,0,0,1-1.793-.033c-.671-.11-.716-.594-.716-1.21v-.7H35.08a2.746,2.746,0,0,1-1.408,1.517,7.006,7.006,0,0,1-2.355.53.609.609,0,0,1-.7-.651c0-.461.374-.516.572-.539,1.221-.131,1.87-.2,2.343-.857H32.8c-.484,0-1.188,0-1.188-.947V5.457c0-.946.7-.957,1.188-.957h5.9c.484,0,1.188.011,1.188.957V7.415c0,.947-.7.947-1.188.947H37.621ZM40.349.782c.176,0,.594,0,.594.593s-.362.606-.594.606H37.511c-.319.451-.858,1.111-1.276,1.111a.644.644,0,0,1-.627-.594c-.045.5-.352.539-.66.539H34.4v.352h1.112c.175,0,.451.022.451.418,0,.318-.176.407-.451.407H32.044c-.947,0-1.156-.177-1.156-1.155V1.453c0-.968.2-1.166,1.156-1.166h3.431A.385.385,0,0,1,35.926.7c0,.364-.252.408-.451.408H34.4V1.5h.551c.23,0,.671,0,.671.627v.264c.021-.209.088-.274.6-.868a4.052,4.052,0,0,0,.529-.781c.242-.451.4-.738.858-.738.231,0,.649.055.649.462a.9.9,0,0,1-.077.32ZM33.242,1.5V1.112h-.935a.2.2,0,0,0-.219.219V1.5Zm-1.154.958h2.167a.193.193,0,1,0,0-.385H32.088Zm1.154.572H32.088c0,.22,0,.363.219.363h.935Zm.089,2.233c-.265,0-.265.177-.265.353H38.49c0-.176,0-.353-.264-.353Zm5.159.99H33.066v.33H38.49Zm-5.424,1c0,.176,0,.352.265.352h4.9c.264,0,.264-.176.264-.352Zm4-3.234a.5.5,0,0,1-.583-.55.5.5,0,0,1,.583-.561h2.971a.5.5,0,0,1,.583.55.506.506,0,0,1-.583.561Z"
                transform="translate(755.979 51)"
                fill="#f7cf91"
              />
              <rect
                id="Rectangle_8488"
                data-name="Rectangle 8488"
                width="40.943"
                height="10.408"
                transform="translate(755.979 51)"
                fill="none"
              />
            </g>
          </svg>

          <div className="border-menu"></div>
        </div>

        <div
          className="item-menu d-flex align-items-center justify-content-center"
          onClick={() => {
            history.push('/guide');
          }}
        >
          <img src={TOP_IMAGES.SvgGuildHeader} className="svg_first svg_first_special" />
          <img src={TOP_IMAGES.SvgGuildHeaderHover} className="svg_last svg_last_special" />
          <div className="border-menu"></div>
        </div>

        {/*<div
          className="item-menu d-flex align-items-center justify-content-center"
          onClick={() => {
            history.push('/lottery');
          }}
        >

        </div>*/}

        {!isLogin ? (
          <div
            className="item-menu d-flex align-items-center justify-content-center"
            onClick={gotoRegister}
          >
            <svg
              className="svg_first"
              xmlns="http://www.w3.org/2000/svg"
              width="43.428"
              height="49.392"
              viewBox="0 0 43.428 49.392"
            >
              <g
                id="Group_12748"
                data-name="Group 12748"
                transform="translate(-1091.823 -4309.657)"
              >
                <path
                  id="Path_67285"
                  data-name="Path 67285"
                  d="M1008.771,49.811c-.407,0-.627-.143-.66-.551a4.884,4.884,0,0,1-1.617.716.769.769,0,0,1-.671-.825c0-.418.264-.551.594-.672a9.565,9.565,0,0,0,3.443-2.332c.44-.429.616-.594,1.188-.594s.715.154,1.353.769a9.208,9.208,0,0,0,3.323,2.2c.33.131.55.253.55.648a.774.774,0,0,1-.7.814,4.657,4.657,0,0,1-1.551-.7c-.055.474-.375.529-.672.529Zm1.518,2.31a17.906,17.906,0,0,1-1.089,2.19c1.562-.056,1.826-.078,4.126-.209-.165-.209-.221-.265-.65-.739-.242-.263-.286-.4-.286-.539,0-.33.408-.627.76-.627a.774.774,0,0,1,.561.288,16.242,16.242,0,0,1,1.462,1.638c.529.66.65.869.65,1.112a.878.878,0,0,1-.859.726.494.494,0,0,1-.439-.242c-.044-.067-.275-.418-.33-.5-1.145.133-2.333.221-3.5.3-.55.045-3.388.209-3.828.209-.176,0-.683,0-.683-.7a.571.571,0,0,1,.495-.639c.1-.011.869-.033,1.034-.033a14.268,14.268,0,0,0,1.057-2.233h-2.035c-.462,0-.672-.209-.672-.693a.581.581,0,0,1,.672-.616h8.6c.451,0,.671.186.671.682a.584.584,0,0,1-.671.627Zm2.7-3.531a10.556,10.556,0,0,1-1.617-1.453c-.165-.176-.21-.22-.309-.22s-.142.044-.307.22a11.35,11.35,0,0,1-1.618,1.453Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67286"
                  data-name="Path 67286"
                  d="M1020.53,54.1a.752.752,0,0,1,.319.594c0,.285-.1.406-.836.681a11.225,11.225,0,0,1-2.442.65c-.441,0-.606-.462-.606-.759,0-.4.22-.451.661-.539a12.888,12.888,0,0,0,2.288-.627h-1c-.782,0-1.189-.265-1.189-1.19V50.229c0-.913.4-1.189,1.189-1.189h6.282c.8,0,1.2.276,1.2,1.189v2.683c0,.915-.407,1.19-1.2,1.19h-.98a11.8,11.8,0,0,0,2.245.638c.484.1.671.143.671.528,0,.23-.121.781-.616.781a11.293,11.293,0,0,1-2.365-.672c-.683-.263-.9-.351-.9-.693a.778.778,0,0,1,.307-.582Zm5.522-6.568c0,.923-.2,1.132-1.154,1.132h-5.677c-.935,0-1.144-.2-1.144-1.132v-.408c0-.913.186-1.133,1.144-1.133h5.677c.945,0,1.154.209,1.154,1.133Zm-1.011,2.937v-.187a.237.237,0,0,0-.264-.264h-5.436a.235.235,0,0,0-.263.264v.187Zm-5.963,1.32h5.963v-.463h-5.963Zm0,.847v.209a.237.237,0,0,0,.263.265h5.436a.24.24,0,0,0,.264-.265v-.209Zm5.611-5.413a.193.193,0,0,0-.221-.22h-4.841c-.142,0-.209.077-.209.22v.242c0,.133.056.221.209.221h4.841a.2.2,0,0,0,.221-.221Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67287"
                  data-name="Path 67287"
                  d="M1031.178,49.866a.494.494,0,0,1-.572-.439,7.2,7.2,0,0,1-2.069,1.012.723.723,0,0,1-.682-.782.565.565,0,0,1,.419-.572,10.7,10.7,0,0,0,1.122-.473c-.1-.11-.451-.44-.683-.649a.5.5,0,0,1-.186-.385.7.7,0,0,1,.67-.637c.166,0,.253.042.638.373a8.988,8.988,0,0,1,.66.617c.232-.177.969-.76.969-.892s-.154-.121-.242-.121h-1.464a.493.493,0,0,1-.571-.517c0-.429.274-.539.571-.539h3.092c.429,0,.594,0,.825.209.121.1.561.627.649.726.088-.077.484-.451.627-.616.408-.44.452-.485.671-.485a.716.716,0,0,1,.7.606c0,.187-.088.308-.428.66-.144.143-.43.439-.7.682a3.929,3.929,0,0,0,.45.352,11.34,11.34,0,0,0,.914-.913c.4-.439.429-.484.638-.484a.751.751,0,0,1,.737.66c0,.2-.32.517-.562.77a6.338,6.338,0,0,1-.616.594,9.408,9.408,0,0,0,1.013.407.562.562,0,0,1,.472.583.756.756,0,0,1-.67.792,2.17,2.17,0,0,1-.826-.242,9.115,9.115,0,0,1-1.254-.7.484.484,0,0,1-.561.406Zm-1.232,3.444c-.936,0-.968-.528-.968-1.155v-.584c0-.934.2-1.154,1.154-1.154h5.854c.946,0,1.155.209,1.155,1.154v.584c0,.616-.033,1.155-.957,1.155h-.4a.368.368,0,0,1,.111.263,6.715,6.715,0,0,1-.276.9h1.805c.253,0,.671.045.671.593,0,.441-.144.684-.671.684h-8.758c-.22,0-.671-.023-.671-.595,0-.428.132-.682.671-.682h1.893a2.967,2.967,0,0,1-.33-.924.326.326,0,0,1,.109-.242Zm5.808-1.628c0-.132-.044-.253-.242-.253h-4.906c-.176,0-.253.076-.253.253v.374a.225.225,0,0,0,.253.253h4.906c.165,0,.242-.088.242-.253Zm-4.214,1.628a3.348,3.348,0,0,1,.342,1,.3.3,0,0,1-.044.164h2.332c.066-.187.165-.44.242-.716.1-.329.1-.362.165-.45Zm2.927-4.6a10.072,10.072,0,0,1-1.419-1.508,8.921,8.921,0,0,1-1.475,1.508Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67288"
                  data-name="Path 67288"
                  d="M1041.782,54.145a5.537,5.537,0,0,1,.781-.131.419.419,0,0,1,.286.1c.044-.032.11-.066.121-.076.385-.232.748-.452.946-.583.682-.462.7-.485.826-.485.3,0,.494.353.494.638a.55.55,0,0,1-.11.33,6.967,6.967,0,0,1-.814.672c-.726.506-.858.594-1.111.594a.488.488,0,0,1-.363-.143,14.692,14.692,0,0,1-3.444.748.444.444,0,0,1-.352-.121.746.746,0,0,1-.187-.528.546.546,0,0,1,.286-.55,10.235,10.235,0,0,1,1.563-.3v-2.85h-1.145c-.439,0-.627-.2-.627-.572,0-.43.275-.56.627-.56h1.145v-.848h-.594a.469.469,0,0,1-.539-.484.407.407,0,0,1-.188.043c-.363,0-.627-.428-.627-.725s.188-.495.529-.793a8.691,8.691,0,0,0,.923-1.012c.529-.715.627-.847,1.145-.847a.92.92,0,0,1,.857.484,12.337,12.337,0,0,0,.9,1.133c.253.275.374.4.374.6a.708.708,0,0,1-.66.639.272.272,0,0,1-.132-.033.7.7,0,0,1,.121.429c0,.561-.385.561-.55.561h-.484v.848h.858c.484,0,.55.285.55.593a.477.477,0,0,1-.55.539h-.858Zm-1.54-1.859a8.528,8.528,0,0,1,.186,1.332c0,.318-.176.516-.571.516s-.418-.186-.463-.528c-.022-.22-.187-1.309-.187-1.4,0-.175.143-.429.583-.429.287,0,.374.175.452.506m2.013-3.938a.621.621,0,0,1,.253.033,9.355,9.355,0,0,1-.9-1.123c-.176-.23-.2-.263-.276-.263s-.1.054-.2.2a13.7,13.7,0,0,1-.869,1.156Zm.99,3.784a9.378,9.378,0,0,1-.3,1.31c-.066.2-.132.362-.429.362-.088,0-.506-.032-.506-.429,0-.087.209-.913.242-1.089.076-.373.11-.561.429-.561.1,0,.561.022.561.407m3.421,2.618c0,1.112-.286,1.233-1.276,1.233-.154,0-.648,0-.781-.012-.473-.055-.484-.56-.484-.648,0-.639.44-.639.617-.639a4.039,4.039,0,0,0,.516,0c.165-.033.176-.209.176-.33v-3.9h-1.771c-.187,0-.539,0-.539-.562,0-.483.253-.571.539-.571h3.542v-.6h-2.992a.445.445,0,0,1-.517-.494c0-.474.308-.518.517-.518h2.992v-.33a.234.234,0,0,0-.263-.263h-2.883a.47.47,0,0,1-.539-.529c0-.407.143-.594.539-.594h3.278c.826,0,1.122.363,1.122,1.2V49.36h.309c.33,0,.483.22.483.539,0,.527-.34.55-.539.55h-2.046v.506a6.38,6.38,0,0,0,.452,1.034,8.019,8.019,0,0,0,.913-.968c.121-.144.219-.265.428-.265a.61.61,0,0,1,.583.584c0,.231-.044.385-.7,1.089-.175.177-.374.386-.571.55a6.469,6.469,0,0,0,1.154,1.155.7.7,0,0,1,.3.474.709.709,0,0,1-.649.759c-.155,0-.308-.034-.815-.55a5.993,5.993,0,0,1-1.089-1.64Zm-2.024-3.4a3.869,3.869,0,0,1,.407.616.655.655,0,0,1,.067.242.638.638,0,0,1-.583.583c-.21,0-.309-.154-.441-.33-.088-.121-.572-.7-.671-.837a.532.532,0,0,1-.121-.339.589.589,0,0,1,.506-.551c.187,0,.319,0,.836.616"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <rect
                  id="Rectangle_7043"
                  data-name="Rectangle 7043"
                  width="27.694"
                  height="30.137"
                  transform="translate(1099.701 4309.657)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67307"
                  data-name="Path 67307"
                  d="M1031.648,12.457a4.1,4.1,0,1,1-4.1-4.1,4.1,4.1,0,0,1,4.1,4.1"
                  transform="translate(86 4303)"
                  fill="#ce323a"
                />
                <path
                  id="Path_67308"
                  data-name="Path 67308"
                  d="M1027.547,17.308a5.06,5.06,0,0,0-5.051,4.764.285.285,0,0,0,.286.3h9.531a.285.285,0,0,0,.286-.3,5.061,5.061,0,0,0-5.052-4.764"
                  transform="translate(86 4303)"
                  fill="#ce323a"
                />
                <line
                  id="Line_669"
                  data-name="Line 669"
                  x2="11.916"
                  transform="translate(1101.986 4328.938)"
                  fill="none"
                  stroke="#ce323a"
                  strokeMiterlimit={10}
                  strokeWidth="1.672"
                />
                <line
                  id="Line_670"
                  data-name="Line 670"
                  x2="8.654"
                  transform="translate(1101.986 4332.89)"
                  fill="none"
                  stroke="#ce323a"
                  strokeMiterlimit={10}
                  strokeWidth="1.672"
                />
                <line
                  id="Line_671"
                  data-name="Line 671"
                  x2="7.087"
                  transform="translate(1101.986 4336.843)"
                  fill="none"
                  stroke="#ce323a"
                  strokeMiterlimit={10}
                  strokeWidth="1.672"
                />
                <rect
                  id="Rectangle_7044"
                  data-name="Rectangle 7044"
                  width="13.387"
                  height="6.944"
                  transform="translate(1114.76 4333.504) rotate(-44.999)"
                  fill="#ce323a"
                />
                <rect
                  id="Rectangle_7045"
                  data-name="Rectangle 7045"
                  width="13.387"
                  height="6.944"
                  transform="translate(1114.76 4333.504) rotate(-44.999)"
                  fill="none"
                  stroke="#ce323a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={4}
                />
                <path
                  id="Path_67309"
                  data-name="Path 67309"
                  d="M1028.76,30.5l2.455,2.455,2.455,2.455-8.386,3.477Z"
                  transform="translate(86 4303)"
                  fill="#ce323a"
                />
                <path
                  id="Path_67310"
                  data-name="Path 67310"
                  d="M1028.76,30.5l2.455,2.455,2.455,2.455-8.386,3.477Z"
                  transform="translate(86 4303)"
                  fill="none"
                  stroke="#ce323a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={4}
                />
                <path
                  id="Path_67311"
                  data-name="Path 67311"
                  d="M1027.022,34.7l1.228,1.228,1.227,1.227-4.193,1.738Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67312"
                  data-name="Path 67312"
                  d="M1027.022,34.7l1.228,1.228,1.227,1.227-4.193,1.738Z"
                  transform="translate(86 4303)"
                  fill="none"
                  stroke="#ce323a"
                  strokeMiterlimit={10}
                  strokeWidth={4}
                />
                <rect
                  id="Rectangle_7046"
                  data-name="Rectangle 7046"
                  width="13.387"
                  height="6.944"
                  transform="translate(1114.76 4333.504) rotate(-44.999)"
                  fill="#ce323a"
                />
                <rect
                  id="Rectangle_7047"
                  data-name="Rectangle 7047"
                  width="13.387"
                  height="6.944"
                  transform="translate(1114.76 4333.504) rotate(-44.999)"
                  fill="none"
                  stroke="#ffffe5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.411"
                />
                <path
                  id="Path_67313"
                  data-name="Path 67313"
                  d="M1028.76,30.5l2.455,2.455,2.455,2.455-8.386,3.477Z"
                  transform="translate(86 4303)"
                  fill="#ce323a"
                />
                <path
                  id="Path_67314"
                  data-name="Path 67314"
                  d="M1028.76,30.5l2.455,2.455,2.455,2.455-8.386,3.477Z"
                  transform="translate(86 4303)"
                  fill="none"
                  stroke="#ffffe5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.411"
                />
                <path
                  id="Path_67315"
                  data-name="Path 67315"
                  d="M1026.763,35.322l2.089,2.089-3.568,1.48Z"
                  transform="translate(86 4303)"
                  fill="#ffffe5"
                />
              </g>
            </svg>

            <svg
              className="svg_last"
              xmlns="http://www.w3.org/2000/svg"
              width="43.428"
              height="49.392"
              viewBox="0 0 43.428 49.392"
            >
              <g id="Group_12848" data-name="Group 12848" transform="translate(-1005 -12.657)">
                <g id="Group_12847" data-name="Group 12847">
                  <path
                    id="Path_67285"
                    data-name="Path 67285"
                    d="M1008.771,49.811c-.407,0-.627-.143-.66-.551a4.884,4.884,0,0,1-1.617.716.769.769,0,0,1-.671-.825c0-.418.264-.551.594-.672a9.565,9.565,0,0,0,3.443-2.332c.44-.429.616-.594,1.188-.594s.715.154,1.353.769a9.208,9.208,0,0,0,3.323,2.2c.33.131.55.253.55.648a.774.774,0,0,1-.7.814,4.657,4.657,0,0,1-1.551-.7c-.055.474-.375.529-.672.529Zm1.518,2.31a17.906,17.906,0,0,1-1.089,2.19c1.562-.056,1.826-.078,4.126-.209-.165-.209-.221-.265-.65-.739-.242-.263-.286-.4-.286-.539,0-.33.408-.627.76-.627a.774.774,0,0,1,.561.288,16.242,16.242,0,0,1,1.462,1.638c.529.66.65.869.65,1.112a.878.878,0,0,1-.859.726.494.494,0,0,1-.439-.242c-.044-.067-.275-.418-.33-.5-1.145.133-2.333.221-3.5.3-.55.045-3.388.209-3.828.209-.176,0-.683,0-.683-.7a.571.571,0,0,1,.495-.639c.1-.011.869-.033,1.034-.033a14.268,14.268,0,0,0,1.057-2.233h-2.035c-.462,0-.672-.209-.672-.693a.581.581,0,0,1,.672-.616h8.6c.451,0,.671.186.671.682a.584.584,0,0,1-.671.627Zm2.7-3.531a10.556,10.556,0,0,1-1.617-1.453c-.165-.176-.21-.22-.309-.22s-.142.044-.307.22a11.35,11.35,0,0,1-1.618,1.453Z"
                    transform="translate(-0.823 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67286"
                    data-name="Path 67286"
                    d="M1020.53,54.1a.752.752,0,0,1,.319.594c0,.285-.1.406-.836.681a11.225,11.225,0,0,1-2.442.65c-.441,0-.606-.462-.606-.759,0-.4.22-.451.661-.539a12.888,12.888,0,0,0,2.288-.627h-1c-.782,0-1.189-.265-1.189-1.19V50.229c0-.913.4-1.189,1.189-1.189h6.282c.8,0,1.2.276,1.2,1.189v2.683c0,.915-.407,1.19-1.2,1.19h-.98a11.8,11.8,0,0,0,2.245.638c.484.1.671.143.671.528,0,.23-.121.781-.616.781a11.293,11.293,0,0,1-2.365-.672c-.683-.263-.9-.351-.9-.693a.778.778,0,0,1,.307-.582Zm5.522-6.568c0,.923-.2,1.132-1.154,1.132h-5.677c-.935,0-1.144-.2-1.144-1.132v-.408c0-.913.186-1.133,1.144-1.133h5.677c.945,0,1.154.209,1.154,1.133Zm-1.011,2.937v-.187a.237.237,0,0,0-.264-.264h-5.436a.235.235,0,0,0-.263.264v.187Zm-5.963,1.32h5.963v-.463h-5.963Zm0,.847v.209a.237.237,0,0,0,.263.265h5.436a.24.24,0,0,0,.264-.265v-.209Zm5.611-5.413a.193.193,0,0,0-.221-.22h-4.841c-.142,0-.209.077-.209.22v.242c0,.133.056.221.209.221h4.841a.2.2,0,0,0,.221-.221Z"
                    transform="translate(-0.823 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67287"
                    data-name="Path 67287"
                    d="M1031.178,49.866a.494.494,0,0,1-.572-.439,7.2,7.2,0,0,1-2.069,1.012.723.723,0,0,1-.682-.782.565.565,0,0,1,.419-.572,10.7,10.7,0,0,0,1.122-.473c-.1-.11-.451-.44-.683-.649a.5.5,0,0,1-.186-.385.7.7,0,0,1,.67-.637c.166,0,.253.042.638.373a8.988,8.988,0,0,1,.66.617c.232-.177.969-.76.969-.892s-.154-.121-.242-.121h-1.464a.493.493,0,0,1-.571-.517c0-.429.274-.539.571-.539h3.092c.429,0,.594,0,.825.209.121.1.561.627.649.726.088-.077.484-.451.627-.616.408-.44.452-.485.671-.485a.716.716,0,0,1,.7.606c0,.187-.088.308-.428.66-.144.143-.43.439-.7.682a3.929,3.929,0,0,0,.45.352,11.34,11.34,0,0,0,.914-.913c.4-.439.429-.484.638-.484a.751.751,0,0,1,.737.66c0,.2-.32.517-.562.77a6.338,6.338,0,0,1-.616.594,9.408,9.408,0,0,0,1.013.407.562.562,0,0,1,.472.583.756.756,0,0,1-.67.792,2.17,2.17,0,0,1-.826-.242,9.115,9.115,0,0,1-1.254-.7.484.484,0,0,1-.561.406Zm-1.232,3.444c-.936,0-.968-.528-.968-1.155v-.584c0-.934.2-1.154,1.154-1.154h5.854c.946,0,1.155.209,1.155,1.154v.584c0,.616-.033,1.155-.957,1.155h-.4a.368.368,0,0,1,.111.263,6.715,6.715,0,0,1-.276.9h1.805c.253,0,.671.045.671.593,0,.441-.144.684-.671.684h-8.758c-.22,0-.671-.023-.671-.595,0-.428.132-.682.671-.682h1.893a2.967,2.967,0,0,1-.33-.924.326.326,0,0,1,.109-.242Zm5.808-1.628c0-.132-.044-.253-.242-.253h-4.906c-.176,0-.253.076-.253.253v.374a.225.225,0,0,0,.253.253h4.906c.165,0,.242-.088.242-.253Zm-4.214,1.628a3.348,3.348,0,0,1,.342,1,.3.3,0,0,1-.044.164h2.332c.066-.187.165-.44.242-.716.1-.329.1-.362.165-.45Zm2.927-4.6a10.072,10.072,0,0,1-1.419-1.508,8.921,8.921,0,0,1-1.475,1.508Z"
                    transform="translate(-0.823 6)"
                    fill="#f7cf91"
                  />
                  <path
                    id="Path_67288"
                    data-name="Path 67288"
                    d="M1041.782,54.145a5.537,5.537,0,0,1,.781-.131.419.419,0,0,1,.286.1c.044-.032.11-.066.121-.076.385-.232.748-.452.946-.583.682-.462.7-.485.826-.485.3,0,.494.353.494.638a.55.55,0,0,1-.11.33,6.967,6.967,0,0,1-.814.672c-.726.506-.858.594-1.111.594a.488.488,0,0,1-.363-.143,14.692,14.692,0,0,1-3.444.748.444.444,0,0,1-.352-.121.746.746,0,0,1-.187-.528.546.546,0,0,1,.286-.55,10.235,10.235,0,0,1,1.563-.3v-2.85h-1.145c-.439,0-.627-.2-.627-.572,0-.43.275-.56.627-.56h1.145v-.848h-.594a.469.469,0,0,1-.539-.484.407.407,0,0,1-.188.043c-.363,0-.627-.428-.627-.725s.188-.495.529-.793a8.691,8.691,0,0,0,.923-1.012c.529-.715.627-.847,1.145-.847a.92.92,0,0,1,.857.484,12.337,12.337,0,0,0,.9,1.133c.253.275.374.4.374.6a.708.708,0,0,1-.66.639.272.272,0,0,1-.132-.033.7.7,0,0,1,.121.429c0,.561-.385.561-.55.561h-.484v.848h.858c.484,0,.55.285.55.593a.477.477,0,0,1-.55.539h-.858Zm-1.54-1.859a8.528,8.528,0,0,1,.186,1.332c0,.318-.176.516-.571.516s-.418-.186-.463-.528c-.022-.22-.187-1.309-.187-1.4,0-.175.143-.429.583-.429.287,0,.374.175.452.506m2.013-3.938a.621.621,0,0,1,.253.033,9.355,9.355,0,0,1-.9-1.123c-.176-.23-.2-.263-.276-.263s-.1.054-.2.2a13.7,13.7,0,0,1-.869,1.156Zm.99,3.784a9.378,9.378,0,0,1-.3,1.31c-.066.2-.132.362-.429.362-.088,0-.506-.032-.506-.429,0-.087.209-.913.242-1.089.076-.373.11-.561.429-.561.1,0,.561.022.561.407m3.421,2.618c0,1.112-.286,1.233-1.276,1.233-.154,0-.648,0-.781-.012-.473-.055-.484-.56-.484-.648,0-.639.44-.639.617-.639a4.039,4.039,0,0,0,.516,0c.165-.033.176-.209.176-.33v-3.9h-1.771c-.187,0-.539,0-.539-.562,0-.483.253-.571.539-.571h3.542v-.6h-2.992a.445.445,0,0,1-.517-.494c0-.474.308-.518.517-.518h2.992v-.33a.234.234,0,0,0-.263-.263h-2.883a.47.47,0,0,1-.539-.529c0-.407.143-.594.539-.594h3.278c.826,0,1.122.363,1.122,1.2V49.36h.309c.33,0,.483.22.483.539,0,.527-.34.55-.539.55h-2.046v.506a6.38,6.38,0,0,0,.452,1.034,8.019,8.019,0,0,0,.913-.968c.121-.144.219-.265.428-.265a.61.61,0,0,1,.583.584c0,.231-.044.385-.7,1.089-.175.177-.374.386-.571.55a6.469,6.469,0,0,0,1.154,1.155.7.7,0,0,1,.3.474.709.709,0,0,1-.649.759c-.155,0-.308-.034-.815-.55a5.993,5.993,0,0,1-1.089-1.64Zm-2.024-3.4a3.869,3.869,0,0,1,.407.616.655.655,0,0,1,.067.242.638.638,0,0,1-.583.583c-.21,0-.309-.154-.441-.33-.088-.121-.572-.7-.671-.837a.532.532,0,0,1-.121-.339.589.589,0,0,1,.506-.551c.187,0,.319,0,.836.616"
                    transform="translate(-0.823 6)"
                    fill="#f7cf91"
                  />
                </g>
                <rect
                  id="Rectangle_7043"
                  data-name="Rectangle 7043"
                  width="27.694"
                  height="30.137"
                  transform="translate(1012.878 12.657)"
                  fill="#f7cf91"
                />
                <path
                  id="Path_67307"
                  data-name="Path 67307"
                  d="M1031.648,12.457a4.1,4.1,0,1,1-4.1-4.1,4.1,4.1,0,0,1,4.1,4.1"
                  transform="translate(-0.823 6)"
                  fill="#ce323a"
                />
                <path
                  id="Path_67308"
                  data-name="Path 67308"
                  d="M1027.547,17.308a5.06,5.06,0,0,0-5.051,4.764.285.285,0,0,0,.286.3h9.531a.285.285,0,0,0,.286-.3,5.061,5.061,0,0,0-5.052-4.764"
                  transform="translate(-0.823 6)"
                  fill="#ce323a"
                />
                <line
                  id="Line_669"
                  data-name="Line 669"
                  x2="11.916"
                  transform="translate(1015.163 31.938)"
                  fill="none"
                  stroke="#ce323a"
                  strokeMiterlimit={10}
                  strokeWidth="1.672"
                />
                <line
                  id="Line_670"
                  data-name="Line 670"
                  x2="8.654"
                  transform="translate(1015.163 35.89)"
                  fill="none"
                  stroke="#ce323a"
                  strokeMiterlimit={10}
                  strokeWidth="1.672"
                />
                <line
                  id="Line_671"
                  data-name="Line 671"
                  x2="7.087"
                  transform="translate(1015.163 39.843)"
                  fill="none"
                  stroke="#ce323a"
                  strokeMiterlimit={10}
                  strokeWidth="1.672"
                />
                <rect
                  id="Rectangle_7044"
                  data-name="Rectangle 7044"
                  width="13.387"
                  height="6.944"
                  transform="translate(1027.937 36.504) rotate(-44.999)"
                  fill="#ce323a"
                />
                <rect
                  id="Rectangle_7045"
                  data-name="Rectangle 7045"
                  width="13.387"
                  height="6.944"
                  transform="translate(1027.937 36.504) rotate(-44.999)"
                  fill="none"
                  stroke="#ce323a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={4}
                />
                <path
                  id="Path_67309"
                  data-name="Path 67309"
                  d="M1028.76,30.5l2.455,2.455,2.455,2.455-8.386,3.477Z"
                  transform="translate(-0.823 6)"
                  fill="#ce323a"
                />
                <path
                  id="Path_67310"
                  data-name="Path 67310"
                  d="M1028.76,30.5l2.455,2.455,2.455,2.455-8.386,3.477Z"
                  transform="translate(-0.823 6)"
                  fill="none"
                  stroke="#ce323a"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={4}
                />
                <path
                  id="Path_67311"
                  data-name="Path 67311"
                  d="M1027.022,34.7l1.228,1.228,1.227,1.227-4.193,1.738Z"
                  transform="translate(-0.823 6)"
                  fill="#ffffe5"
                />
                <path
                  id="Path_67312"
                  data-name="Path 67312"
                  d="M1027.022,34.7l1.228,1.228,1.227,1.227-4.193,1.738Z"
                  transform="translate(-0.823 6)"
                  fill="none"
                  stroke="#ce323a"
                  strokeMiterlimit={10}
                  strokeWidth={4}
                />
                <rect
                  id="Rectangle_7046"
                  data-name="Rectangle 7046"
                  width="13.387"
                  height="6.944"
                  transform="translate(1027.937 36.504) rotate(-44.999)"
                  fill="#ce323a"
                />
                <rect
                  id="Rectangle_7047"
                  data-name="Rectangle 7047"
                  width="13.387"
                  height="6.944"
                  transform="translate(1027.937 36.504) rotate(-44.999)"
                  fill="none"
                  stroke="#f7cf91"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.411"
                />
                <path
                  id="Path_67313"
                  data-name="Path 67313"
                  d="M1028.76,30.5l2.455,2.455,2.455,2.455-8.386,3.477Z"
                  transform="translate(-0.823 6)"
                  fill="#ce323a"
                />
                <path
                  id="Path_67314"
                  data-name="Path 67314"
                  d="M1028.76,30.5l2.455,2.455,2.455,2.455-8.386,3.477Z"
                  transform="translate(-0.823 6)"
                  fill="none"
                  stroke="#f7cf91"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.411"
                />
                <path
                  id="Path_67315"
                  data-name="Path 67315"
                  d="M1026.763,35.322l2.089,2.089-3.568,1.48Z"
                  transform="translate(-0.823 6)"
                  fill="#f7cf91"
                />
              </g>
            </svg>
            <div className="border-menu"></div>
          </div>
        ) : (
          <div />
        )}
        <div className="sub-menu d-flex align-items-center justify-content-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40.14"
            height="45.144"
            viewBox="0 0 40.14 45.144"
            className="svg_first"
          >
            <g id="Group_12745" data-name="Group 12745" transform="translate(-1208.352 -4313.442)">
              <path
                id="Path_67273"
                data-name="Path 67273"
                d="M1124.123,48.92c-.341-.208-.539-.363-.539-.66a.757.757,0,0,1,.693-.759c.232,0,.495.1,1.3.627.892.594,1.607,1.078,2.135,1.474A18.036,18.036,0,0,0,1129,46.576c.121-.329.253-.56.66-.56.32,0,.869.154.869.671a15.059,15.059,0,0,1-1.694,3.785,23.233,23.233,0,0,1,1.859,1.594c.539.517.65.682.65.946a.868.868,0,0,1-.837.847,1,1,0,0,1-.726-.383c-1.078-1.112-1.243-1.278-1.793-1.761a14.59,14.59,0,0,1-3,2.926,3.857,3.857,0,0,1-1.859.945.822.822,0,0,1-.77-.8c0-.33.2-.429.7-.693a10.409,10.409,0,0,0,3.85-3.255,29.953,29.953,0,0,0-2.784-1.915"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
              <path
                id="Path_67274"
                data-name="Path 67274"
                d="M1141.658,53.321a.645.645,0,0,1,.726.715.637.637,0,0,1-.726.727H1133.4a.721.721,0,1,1,0-1.442Zm-.814-6.37a.72.72,0,1,1,0,1.44h-6.667a.65.65,0,0,1-.737-.714.642.642,0,0,1,.737-.726Z"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
              <path
                id="Path_67275"
                data-name="Path 67275"
                d="M1150.757,53.782a.6.6,0,0,1,.671.66.586.586,0,0,1-.671.66h-6.711a.66.66,0,1,1,0-1.32h3.96c.177-1.11.374-3.333.374-3.686,0-.252-.1-.306-.341-.306h-3.146a.666.666,0,1,1,0-1.332h3.894a.952.952,0,0,1,1.057,1.078c0,.231-.088,1.64-.441,4.246Z"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
              <path
                id="Path_67276"
                data-name="Path 67276"
                d="M1153.494,51.6c-.243,0-.815,0-.815-.748,0-.715.495-.76.815-.76h8.185a.69.69,0,0,1,.813.749c0,.738-.517.759-.813.759Z"
                transform="translate(86 4303)"
                fill="#ffffe5"
              />
              <line
                id="Line_665"
                data-name="Line 665"
                x2="28.333"
                transform="translate(1214.349 4315.942)"
                fill="none"
                stroke="#ffffe5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={5}
              />
              <line
                id="Line_666"
                data-name="Line 666"
                x2="28.333"
                transform="translate(1214.349 4326.214)"
                fill="none"
                stroke="#ffffe5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={5}
              />
              <line
                id="Line_667"
                data-name="Line 667"
                x2="28.333"
                transform="translate(1214.349 4336.486)"
                fill="none"
                stroke="#ffffe5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={5}
              />
            </g>
          </svg>
          <svg
            className="svg_last"
            xmlns="http://www.w3.org/2000/svg"
            width="40.14"
            height="45.144"
            viewBox="0 0 40.14 45.144"
          >
            <g id="Group_12851" data-name="Group 12851" transform="translate(-1122.352 -16.442)">
              <g id="Group_12849" data-name="Group 12849">
                <path
                  id="Path_67273"
                  data-name="Path 67273"
                  d="M1124.123,48.92c-.341-.208-.539-.363-.539-.66a.757.757,0,0,1,.693-.759c.232,0,.495.1,1.3.627.892.594,1.607,1.078,2.135,1.474A18.036,18.036,0,0,0,1129,46.576c.121-.329.253-.56.66-.56.32,0,.869.154.869.671a15.059,15.059,0,0,1-1.694,3.785,23.233,23.233,0,0,1,1.859,1.594c.539.517.65.682.65.946a.868.868,0,0,1-.837.847,1,1,0,0,1-.726-.383c-1.078-1.112-1.243-1.278-1.793-1.761a14.59,14.59,0,0,1-3,2.926,3.857,3.857,0,0,1-1.859.945.822.822,0,0,1-.77-.8c0-.33.2-.429.7-.693a10.409,10.409,0,0,0,3.85-3.255,29.953,29.953,0,0,0-2.784-1.915"
                  transform="translate(0 6)"
                  fill="#f7cf91"
                />
                <path
                  id="Path_67274"
                  data-name="Path 67274"
                  d="M1141.658,53.321a.645.645,0,0,1,.726.715.637.637,0,0,1-.726.727H1133.4a.721.721,0,1,1,0-1.442Zm-.814-6.37a.72.72,0,1,1,0,1.44h-6.667a.65.65,0,0,1-.737-.714.642.642,0,0,1,.737-.726Z"
                  transform="translate(0 6)"
                  fill="#f7cf91"
                />
                <path
                  id="Path_67275"
                  data-name="Path 67275"
                  d="M1150.757,53.782a.6.6,0,0,1,.671.66.586.586,0,0,1-.671.66h-6.711a.66.66,0,1,1,0-1.32h3.96c.177-1.11.374-3.333.374-3.686,0-.252-.1-.306-.341-.306h-3.146a.666.666,0,1,1,0-1.332h3.894a.952.952,0,0,1,1.057,1.078c0,.231-.088,1.64-.441,4.246Z"
                  transform="translate(0 6)"
                  fill="#f7cf91"
                />
                <path
                  id="Path_67276"
                  data-name="Path 67276"
                  d="M1153.494,51.6c-.243,0-.815,0-.815-.748,0-.715.495-.76.815-.76h8.185a.69.69,0,0,1,.813.749c0,.738-.517.759-.813.759Z"
                  transform="translate(0 6)"
                  fill="#f7cf91"
                />
              </g>
              <g id="Group_12850" data-name="Group 12850">
                <line
                  id="Line_665"
                  data-name="Line 665"
                  x2="28.333"
                  transform="translate(1128.349 18.942)"
                  fill="none"
                  stroke="#f7cf91"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={5}
                />
                <line
                  id="Line_666"
                  data-name="Line 666"
                  x2="28.333"
                  transform="translate(1128.349 29.214)"
                  fill="none"
                  stroke="#f7cf91"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={5}
                />
                <line
                  id="Line_667"
                  data-name="Line 667"
                  x2="28.333"
                  transform="translate(1128.349 39.486)"
                  fill="none"
                  stroke="#f7cf91"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={5}
                />
              </g>
            </g>
          </svg>
          <div className="border-menu"></div>

          <div className="sub-menu-wrapper">
            <div id="icon-wrapper">
              <svg
                id="dropdown-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="12"
                viewBox="0 0 18 12"
              >
                <path
                  id="Polygon_5"
                  data-name="Polygon 5"
                  d="M9,0l9,12H0Z"
                  transform="translate(18 12) rotate(180)"
                  fill="#464646"
                  stroke="#fff"
                  strokeWidth={2}
                />
              </svg>
            </div>
            {isLogin ? (
              <div className="sub-menu-item-wrap">
                <div className="sub-menu-item" onClick={gotoMyPage}>
                  {t('menu.myPage')}
                </div>
                <div className="sub-menu-item" onClick={gotoPurchaseHistory}>
                  {t('menu.purchaseHistory')}
                </div>
                <div className="sub-menu-item" onClick={gotoMyCollection}>
                  {t('menu.myCollection')}
                </div>
                <div className="sub-menu-item" onClick={gotoLottery}>
                  {t('menu.Lottery')}
                </div>
                <div className="sub-menu-item" onClick={gotoGuide}>
                  {t('menu.Guide')}
                </div>
                <div className="sub-menu-item" onClick={gotoFrequentlyQuestion}>
                  {t('menu.FrequentlyQuestion')}
                </div>
                <div className="sub-menu-item" onClick={handleLogout}>
                  {t('logout')}
                </div>
              </div>
            ) : (
              <div className="sub-menu-item-wrap">
                <div className="sub-menu-item" onClick={gotoLogin}>
                  {t('login')}
                </div>
                <div className="sub-menu-item" onClick={gotoLottery}>
                  {t('menu.Lottery')}
                </div>
                <div className="sub-menu-item" onClick={gotoGuide}>
                  {t('menu.Guide')}
                </div>
                <div className="sub-menu-item" onClick={gotoFrequentlyQuestion}>
                  {t('menu.FrequentlyQuestion')}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
